import React from "react";
import {
  QueryVirtualLoopsData,
  SubscribeVirtualLoopsData,
} from "../../../utils/graphql/hooks/virtualLoopsHooks";

export default function VirtualLoopsDataManager() {
  QueryVirtualLoopsData();
  SubscribeVirtualLoopsData();
  return <></>;
}
